<template>
  <div
    class="splash-screen-wrapper"
    data-sb-regression="sb-splash-screen"
  >
    <div
      id="splash_screen"
      ref="splashScreen"
      class="canvas-wrapper"
    >
      <canvas ref="splashCanvas" />
    </div>
    <div class="loading">
      <p>
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
import { SplashRenderer } from '@src/components/Loading/utils/drawShipBobSplash';

/**
 * Splash screen!
 */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Splash',
  props: {
    /**
     * Current message to be rendered during the display of the splash screen.
     */
    message: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const $splashCanvas = this.$refs.splashCanvas;
    const $splashScreen = this.$refs.splashScreen;

    const context = $splashCanvas.getContext('2d');

    SplashRenderer.DrawSplash(context, $splashScreen);
  },
  unmounted() {
    SplashRenderer.DeleteSplash();
  },
};
</script>

<style scoped lang='scss'>
	@import '@src/components/Loading/style/sb-splash.scss'
</style>>
